import * as THREE from 'three';
import { Shaders } from '../../../../public/libs/shaders/shaders.js';

export class NormalizationMaterial extends THREE.RawShaderMaterial {
    constructor(parameters = {}) {
        super();
        
        this.glslVersion = THREE.GLSL3;

        let uniforms = {
            uDepthMap: { type: 't', value: null },
            uWeightMap: { type: 't', value: null },
        };

        let vs = Shaders['normalize.vs'];
        let fs = Shaders['normalize.fs'];
        let defines = this.getDefines();
        
        // With glslVersion = GLSL3, THREE.js handles #version automatically
        vs = `${defines}${vs}`;
        fs = `${defines}${fs}`;

        this.setValues({
            uniforms: uniforms,
            vertexShader: vs,
            fragmentShader: fs,
        });
    }

    getDefines() {
        let defines = '';

        return defines;
    }

    updateShaderSource() {
        let vs = Shaders['normalize.vs'];
        let fs = Shaders['normalize.fs'];
        let defines = this.getDefines();
        
        // With glslVersion = GLSL3, THREE.js handles #version automatically
        vs = `${defines}${vs}`;
        fs = `${defines}${fs}`;

        this.setValues({
            vertexShader: vs,
            fragmentShader: fs,
        });

        this.needsUpdate = true;
    }
}
